module.exports = __webpack_public_path__ + "img/50.counter.6ae845e2.svg";